import React from "react";

import Section from "../Section";

import { pageTitle } from "../../helpers/PageTitle";

import { Helmet } from "react-helmet";
import Spacing from "../Spacing";

export default function HyperHypothermiaUnitPlus() {
  pageTitle("Department Details");
  return (
    <>
      <Helmet>
        <title>
          Mercury Mini – Portable Heater-Cooler Unit for Surgery | Mercury
          Healthcare Manufacturer & Supplier
        </title>

        <meta
          name="Keyword"
          content="Heater cooler machine, Heater cooler unit, Hyper-Hypothermia, Hyper-Hypothermia unit, Hyper-Hypothermia Machine Manufacture, Heater Cooler Machine, Fast Cooling machine, Fast Cooling, Hypothermia Machine"
        />
        <meta
          name="description"
          content="Mercury Mini is a portable heater-cooler unit for ECMO, ICU, and pediatric surgeries. Features a 5L tank, dual output, touch control, and fast heating."
        />
        {/* Google Tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"
        ></script>
        <script>
          {`
         window.dataLayer = window.dataLayer || [];
         function gtag(){dataLayer.push(arguments);}
         gtag('js', new Date());
         gtag('config', 'G-MGF4V7P4YB');
       `}
        </script>
      </Helmet>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="cs_doctor_details">
          <div className="cs_doctor_details_bg cs_bg_filed" />
          <Spacing md="85" />
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                  <img
                    src="/images/departments/Hyper-Hypothermia Unit 1 Plus.png"
                    alt="Doctor"
                    className="w-100 cs_radius_20 "
                  />
                  <h3
                    className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                    style={{
                      padding: "14px 15px",
                    }}
                  >
                    Hyper Hypothermia Unit Plus
                  </h3>
                </div>
              </div>
              <div className="col-lg-6   position-relative">
                <Spacing md="55" />
                <h1
                  className="cs_fs_120 mb-0 cs_semibold"
                  style={{
                    fontSize: "45px",
                    color: "#3f48cc",
                  }}
                >
                  {" "}
                  Hyper Hypothermia Unit Plus (Patent applied for)
                </h1>

                <Spacing md="32" />
                <p className="mb-0 cs_heading_color">
                  {" "}
                  Mercury Hyper-Hypothermia 1 Plus machine (Patent applied for) comes equipped with
                  an advanced Wi-Fi remote controller with a 10-meter range,
                  allowing seamless and efficient operation from a distance. HHU
                  is used to lower/raise/maintain the blood temperature through
                  conductive heat transfer with the help of oxygenator/ heat
                  exchanger, along with the use of a blanket under the patient
                  for rewarming phase if needed. The user regulates the desired
                  fluid temperature with continuous monitoring. It also features
                  a separate cardiopledgia circuit to maintain cardiopledgia
                  temperature.
                </p>

                <Spacing md="32" />
                <h4 className="underline"> Applications</h4>
                <p
                  style={{
                    color: "#274760",
                  }}
                >
                  {" "}
                  The Mercury Hyper-Hypothermia Unit can be used for the
                  surgeries like; Arterial/ ventricular Septal Defects, CABG
                  (Coronary Artery Bypass Grafting), Heart valve replacement
                  (MVR, AVR & PVR), Congenital Surgeries, Hypothermic Surgeries
                  and also can be used in ICU to maintain temperature of
                  patient.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="container">
          <div className="img-details-container">
            {/* Left Section: Features and Product Images */}
            <div className="left-section">
              {/* Title */}
              {/* <h2>{item.tittle}</h2> */}

              {/* Features List */}
              <div className="featureList">
                <h4 className="underline">Features</h4>

                <div className="listdata">
                  <ul>
                    <li>
                      <strong>Fastest Heating & Cooling in it's Class:</strong>{" "}
                      It has separate cooling tank and heating chambers to
                      achieve desired set point quickly.
                    </li>
                    <li>
                      <strong>Graphical User Interface:</strong> Visual & easy
                      to use graphical interface for water flow, heating &
                      cooling temperature, water level indicator.
                    </li>
                    <li>
                      <strong>Fully Touch Controller Display:</strong> All
                      parameter can be controlled on finger touch.
                    </li>
                    {/* <li>
                      <strong>Robust Design:</strong> Robust design including
                      PLCC based electronic to avoid periodic repairs.
                    </li>
                    <li>
                      <strong>Two Output Circuits:</strong> It can be used to
                      support two patient simultaneously.
                    </li>
                    <li>
                      <strong>Heater Off Mode:</strong> In case of cold water
                      circulation is needed “Heater Off” mode can be used and
                      temperature can be lowered further by adding ice in a
                      tank.
                    </li> */}
                    <li>
                      <strong>Diagnostic Mode:</strong> Introducing first ever
                      diagnostic mode for troubleshooting remotely.
                    </li>
                    <li>
                      <strong>Emergency Manual Mode:</strong> In case of
                      emergency Manual mode with interactive colorful keys.
                    </li>
                    <li>
                      <strong>Custom Configuration:</strong> HHU can be
                      configurable according to customer's requirement.
                    </li>
                    <li>
                      <strong>Auto-Cleaning Mode:</strong> Auto cleaning mode
                      for descaling and disinfecting the unit.
                    </li>
                    <li>
                      <strong>Independent Operation:</strong> Independent
                      heating and cooling for Cardiopledgia and patient
                      circuits.
                    </li>
                    <li>
                      <strong>The Unit Offers Additional Feature:</strong> It
                      can be operated with a wireless remote having a 10-meter
                      range.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Product Images */}
              {/* <div className="Bottomside">
 
                 <img src="/images/departments/Mercury Mini.jpg" />
                 <img src="/images/departments/Mercury Mini.jpg" />
                 <img src="/images/departments/Mercury Mini.jpg" />
                 <img src="/images/departments/Mercury Mini.jpg" />
                 <img src="/images/departments/Mercury Mini.jpg" />
 
               </div> */}
            </div>

            {/* Right Section: Side Images */}
            {/* <div className="rightside">
 
               <img src="/images/departments/Mercury Mini.jpg" />
               <img src="/images/departments/Mercury Mini.jpg" />
               <img src="/images/departments/Mercury Mini.jpg" />
 
             </div> */}
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={10} bottomLg={90}>
        <div className="container">
          <h3 className="underline">Specifications</h3>
          <div className="specification">
            <div className="leftside-specification">
              <div>
                <h4 style={{fontSize:"16px"}}>Dimensions:</h4>
                <ul>
                  <li> Height: 35.1" (89.2 cm) </li>
                  <li> Width: 20.7" (52.3 cm) </li>
                  <li>Length: 24.5" (62.2 cm) </li>
                  <li> Weight: 247 lbs. (112kg)</li>
                </ul>
              </div>
              <div>
                <h4 style={{fontSize:"16px"}}> Power Supply: </h4>
                <ul>
                  <li> Voltage: 220 VAC, 1 Phase </li>
                  <li> Frequency: 50Hz </li>
                  <li> Current: 25A </li>
                  <li> Leakage Current: 500mA max </li>
                </ul>
              </div>
            
              <div>
                <h4 style={{fontSize:"16px"}}> Compressor : </h4>
                <ul>
                  <li> Capacity: 1.5 Ton </li>
                </ul>
              </div>
              <div>
                <h4 style={{fontSize:"16px"}}> Output Ports: </h4>
                <ul>
                  <li> Patient/Oxygenator: Quick Connect, 10 Ltr/min </li>
                  <li> Patient/Blanket: Quick Connect, 2 Ltr/min </li>
                  <li> Cardioplegia: Quick Connect, 10 Ltr/min </li>
                </ul>
              </div>
            </div>
            <div className="rightside-specification">
              <div>
                <h4>Cooling Water Tank: </h4>
                <ul>
                  <li> Capacity: 23 Liter (6.1 Gal), Single tank</li>
                  <li>Size: 27 x 29.5 x 34.5 CMs</li>
                </ul>
              </div>

              <div>
                <h4>Heating Chamber: </h4>
                <ul>
                  <li>Patient Chamber: 1 Liter </li>
                  <li>Patient Heater Wattage: 2000 Watt</li>
                  <li>Cardioplegia Chamber: 1 Liter</li>
                  <li>Cardioplegia Heater Wattage: 1000 Watt</li>
                </ul>
              </div>
              <div>
                <h4>Auto Cleaning: </h4>
                <ul>
                  <li>Maximum Temperature: 70°C (158°F) </li>
                  <li>Cleaning & Disinfection Time: 3 Hrs.</li>
                </ul>
              </div>
              <div>
                <h4>Temperature Range: </h4>
                <ul>
                  <li>Output Water Temp Range: 3-42°C
                  (37-107°F) </li>
                 
                </ul>
              </div>
            </div>
          </div>

          <Spacing md="32" />
        </div>{" "}
      </Section>
    </>
  );
}
